<template>
  <InfoWindow
    v-if="location?.city && location?.state"
    class="flex-center flex-col gap-1"
    v-bind="{ options }"
  >
    <span>{{ title() }}</span>
    <span class="font-semibold text-xl">{{ capitalizeWords(location.city) }}, {{ location.state }}</span>
  </InfoWindow>
</template>

<script setup lang="ts">
import { InfoWindow } from 'vue3-google-map'
import type { ScanEvent, Shipment } from '@/types'
import { capitalizeWords } from '@/utils/string'

export interface Props {
  shipment: Shipment
  mostRecentLocation?: ScanEvent
  // eslint-disable-next-line no-undef
  options: google.maps.InfoWindowOptions
}

const props = defineProps<Props>()
const location = props.mostRecentLocation?.location

const title = () => {
  const { status } = props.shipment
  if (status === 'available_for_pickup') {
    return 'Available for Pickup'
  }
  if (status === 'delivered') {
    return 'Delivered'
  }

  return 'Current Shipment Location'
}
</script>
